<script>
import {mapActions} from "vuex";
import common from "@/mixins/common.vue";

export default {
  name: "OrderView",
  mixins: [common],
  data(){
    return {
      orderInfo: null,
      prizeList: [],
      prizeCount: 0,
    }
  },
  created() {
    this.orderId = this.$route.query.orderId;
    if (this.orderId!==''){
      this.loadData();
    }
  },
  methods:{
    ...mapActions(['getOrderList'],),
    async loadData(){
      try {
        let searchQuery = [];
        searchQuery.push({ key: 'orderId' , value: this.orderId });

        this.loading = true;
        const res = await this.getOrderList({
          pageIndex: 1,
          limit: 1,
          startDate: `2023-01-01 00:00:00`,
          endDate: `${new Date().getFullYear()}-12-31 23:59:59`,
          searchQuery: searchQuery,
        });

        if (res.data.statusCode === 0){
          const list = res.data.data.list;
          if (list.length){
            this.orderInfo = list[0];
            this.prizeList = this.runCategorizedPrizes(this.orderInfo.carts).sort((p1, p2)=>p1.category.localeCompare(p2.category));
            this.prizeCount = 0;
            for (let prize of this.prizeList){
              this.prizeCount += prize.count;
            }
            console.log(`orderView ${JSON.stringify(this.prizeList)}`);
          }
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(`getOrderList error`, e.stack);
      }
    },
    runCategorizedPrizes(prizeList){ // 合併分類
      const categorizedPrizes = prizeList.reduce((acc, prize) => {
        // 如果分類不存在，則初始化
        const category = `${prize.categoryId}`;
        if (!acc[category]) {
          acc[category] = {
            count: 0,
            prizes: []
          };
        }

        // 累加數量和將獎品加入對應的分類
        acc[category].count++;
        acc[category].prizes.push(prize);

        return acc;
      }, {});

      const aggregatedPrizes = Object.keys(categorizedPrizes).map(category => {
        const { count, prizes } = categorizedPrizes[category];

        // 假設所有同分類的獎品有相同的「品名」和「圖片」
        const firstPrize = prizes[0];

        return {
          count,
          productName: firstPrize.productName,
          name: `${firstPrize.name}`,
          imageUrl: firstPrize.imageUrl,
          category: firstPrize.category,
          vendorName: firstPrize.vendorName,
          storageName: firstPrize.storageName,
        };
      });

      return aggregatedPrizes;
    },
    getCategoryName(category){
      if (category === 'Last'){
        return `最後賞`
      }
      return `${category}賞`
    },
    findStoreType(type){
      if (type === 'PICKUP'){
        return '自取';
      }
      if (type === 'POST-out'){
        return '宅配-離島運送';
      }
      if (type === 'POST-international'){
        return '國際運送';
      }
      if (type === 'UNIMARTC2C'){
        return '7-11';
      }
      if (type === 'FAMIC2C'){
        return '全家';
      }
      return '宅配-本島運送';
    }
  }
}
</script>

<template>
  <v-container v-if="orderInfo">
    <v-row>
      <v-col cols="12">
        <h1 style="text-align: center">出貨單</h1>
      </v-col>
    </v-row>

    <!-- 寄送資訊 -->
    <v-row>
      <v-col cols="6">
        <h2>寄送資訊</h2>
        <p>Email：{{ orderInfo.email }}</p>
        <p>暱稱：{{ orderInfo.nickname }}</p>
        <p>姓名：{{ orderInfo.name }}</p>
        <p>電話：{{ orderInfo.cellphone }}</p>
        <template v-if="orderInfo.shippingType === 'POST' || orderInfo.shippingType === 'POST-out' || orderInfo.shippingType === 'POST-international'">
          <p>{{ findStoreType(orderInfo.shippingType) }}</p>
          <p>郵遞區號：{{ orderInfo.zipCode }}</p>
          <p>地址：{{ orderInfo.city }}{{ orderInfo.district }}{{ orderInfo.address }}</p>
        </template>
        <template v-else-if="orderInfo.shippingType === 'PICKUP'">
          <p>自取</p>
        </template>
        <template v-else-if="orderInfo.shippingType === 'POST-international'">
          <p>國際配送</p>
          <p>地址：{{ orderInfo.address }}</p>
        </template>
        <template v-else>
          <p>超取門市：{{ findStoreType(orderInfo.storeType) }}</p>
          <p>門市代號：{{ orderInfo.storeId }}</p>
          <p>門市名稱：{{ orderInfo.storeName }}</p>
          <p>門市地址：{{ orderInfo.storeAddress }}</p>
          <p>物流單號：<b>{{ orderInfo.shippingCode}}{{ orderInfo.shippingNumber }}</b></p>
        </template>
      </v-col>

      <!-- 訂單編號 & 總額 -->
      <v-col cols="6">
        <h2>訂單資訊</h2>
        <p>訂單編號：<b>{{ orderInfo.displayId }}</b></p>
        <p>訂單日期：{{ orderInfo.createdDate }}</p>
        <p>訂單總額：<b>{{ orderInfo.invoicePrice }}元</b></p>
        <p>運費總額：<b>{{ orderInfo.shippingPrice }}元</b></p>
        <p>出貨總數：<b>{{ prizeCount }}個</b></p>
        <p>訂單備註：<b>{{ orderInfo.comment }}</b></p>
        <p v-if="prizeList.length">訂單廠商：<b>{{ prizeList[0].vendorName }}</b></p>
      </v-col>
    </v-row>

    <!-- 商品列表 -->
    <v-row>
      <v-col cols="12">
        <h2>商品列表</h2>
        <v-simple-table style="border: 1px solid black;">
          <template v-slot:default>
            <thead>
            <tr>
              <th style="width: 25%;">商品名稱</th>
              <th style="width: 25%;">賞品名稱</th>
              <th style="width: 15%;">商品圖片</th>
<!--              <th>供應商</th>-->
              <th>類型</th>
              <th>數量</th>
              <th>儲位</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in prizeList" :key="i">
              <td><b>{{ item.productName }}</b></td>
              <td><b>{{ item.name }}</b></td>
              <td style="text-align: center">
                <img :src="item.imageUrl" height="150">
              </td>
<!--              <td style="text-align: center"><b>{{ item.vendorName }}</b></td>-->
              <td style="text-align: center"><b>{{ getCategoryName(item.category) }}</b></td>
              <td style="text-align: center; font-size: 20px;"><b>{{ item.count }}</b></td>
              <td style="text-align: center"><b>{{ item.storageName }}</b></td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>
